import { connect } from "react-redux";
import PersistentAudioPlayer from "./components";
import { stopAudio, nextTrack, prevTrack, removeFromQueue, selectQueueTrack, setPlaying } from "../../../actions";

const mapStateToProps = (state) => ({
  currentTrack: state.audio.queue[state.audio.currentIndex],
  queue: state.audio.queue,
  currentIndex: state.audio.currentIndex,
  isPlaying: state.audio.isPlaying,
  lastUpdated: state.audio.lastUpdated,
});

const mapDispatchToProps = (dispatch) => ({
  stopAudio: () => dispatch(stopAudio()),
  nextTrack: () => dispatch(nextTrack()),
  prevTrack: () => dispatch(prevTrack()),
  removeFromQueue: (index) => dispatch(removeFromQueue(index)),
  selectQueueTrack: (index) => dispatch(selectQueueTrack(index)),
  setPlaying: (isPlaying) => dispatch(setPlaying(isPlaying)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PersistentAudioPlayer);
